import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoaderService {
    private activeRequests = 0;
    private loadingSubject = new BehaviorSubject<boolean>(false);

    readonly loading$: Observable<boolean> = this.loadingSubject.asObservable();

    show(): void {
        this.activeRequests++;
        if (this.activeRequests === 1) {
            this.loadingSubject.next(true);
        }
    }

    hide(): void {
        if (this.activeRequests > 0) {
            this.activeRequests--;
        }
        if (this.activeRequests === 0) {
            this.loadingSubject.next(false);
        }
    }
}
